export default __webpack_public_path__ + "static/img/app-logo@2x.5178a0.png";